function initHomepageHeroVideo() {
    const videoContainer = document.querySelector('.homepage-hero__video');
    const videoFrame = document.getElementById('homepage-hero-video');
    const poster = videoContainer?.querySelector('.homepage-hero__poster');

    if (!videoContainer || !videoFrame || videoFrame.dataset.youtubeInitialized === 'true') {
        return;
    }

    videoFrame.dataset.youtubeInitialized = 'true';

    if (poster) {
        poster.addEventListener('error', () => {
            const fallback = poster.dataset.ytFallback;

            if (fallback && poster.src !== fallback) {
                poster.src = fallback;
            }
        }, { once: true });
    }

    let revealed = false;
    let playAttempts = 0;
    let playTimer = null;
    let ytPlayer = null;

    const YT_ORIGINS = [
        'https://www.youtube.com',
        'https://www.youtube-nocookie.com',
        'https://youtube.com',
    ];

    const revealVideo = () => {
        if (revealed) {
            return;
        }

        revealed = true;
        videoContainer.classList.add('is-playing');

        if (playTimer) {
            window.clearInterval(playTimer);
            playTimer = null;
        }
    };

    const postCommand = (func, args = []) => {
        if (!videoFrame.contentWindow) {
            return;
        }

        const payload = JSON.stringify({
            event: 'command',
            func,
            args,
        });

        YT_ORIGINS.forEach((origin) => {
            try {
                videoFrame.contentWindow.postMessage(payload, origin);
            } catch (error) {
                // Cross-origin host may reject a specific target.
            }
        });
    };

    const requestPlay = () => {
        playAttempts += 1;

        if (ytPlayer && typeof ytPlayer.mute === 'function') {
            try {
                ytPlayer.mute();
                ytPlayer.playVideo();
                return;
            } catch (error) {
                // Fall through to postMessage.
            }
        }

        postCommand('mute');
        postCommand('playVideo');
    };

    const startPlayRetries = () => {
        requestPlay();

        if (playTimer) {
            return;
        }

        // Autoplay is flaky on local/privacy browsers — keep nudging for ~20s.
        playTimer = window.setInterval(() => {
            if (revealed || playAttempts >= 20) {
                window.clearInterval(playTimer);
                playTimer = null;
                return;
            }

            requestPlay();
        }, 1000);
    };

    const handleYouTubeMessage = (event) => {
        if (!YT_ORIGINS.some((origin) => event.origin === origin)) {
            return;
        }

        let data = event.data;

        if (typeof data === 'string') {
            try {
                data = JSON.parse(data);
            } catch (error) {
                return;
            }
        }

        if (!data || typeof data !== 'object') {
            return;
        }

        const state = typeof data.info === 'object' && data.info !== null
            ? data.info.playerState
            : data.info;

        // 1 = PLAYING
        if (data.event === 'onStateChange' && state === 1) {
            revealVideo();
            return;
        }

        if (data.event === 'infoDelivery' && state === 1) {
            revealVideo();
        }
    };

    window.addEventListener('message', handleYouTubeMessage);

    const bindIframeApi = () => {
        videoFrame.contentWindow?.postMessage(
            JSON.stringify({ event: 'listening', id: videoFrame.id }),
            '*'
        );
        startPlayRetries();
    };

    videoFrame.addEventListener('load', bindIframeApi, { once: true });

    // If the iframe already loaded before this script ran.
    if (videoFrame.contentWindow) {
        bindIframeApi();
    }

    const createPlayer = () => {
        if (!window.YT || typeof window.YT.Player !== 'function') {
            return;
        }

        ytPlayer = new window.YT.Player(videoFrame, {
            events: {
                onReady(event) {
                    ytPlayer = event.target;
                    startPlayRetries();
                },
                onStateChange(event) {
                    if (event.data === window.YT.PlayerState.PLAYING) {
                        revealVideo();
                    }
                },
                onError() {
                    // Keep poster visible; retries may still recover.
                },
            },
        });
    };

    if (window.YT && window.YT.Player) {
        createPlayer();
        return;
    }

    const previousReady = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
        if (typeof previousReady === 'function') {
            previousReady();
        }

        createPlayer();
    };

    if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        const apiScript = document.createElement('script');
        apiScript.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(apiScript);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomepageHeroVideo, { once: true });
} else {
    initHomepageHeroVideo();
}

window.addEventListener('pageshow', initHomepageHeroVideo);
